import Router from "./routes";
import "./assets/css/login.css";
import "./assets/css/style.css";
import ThemeConfig from "./theme";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./hooks/useAuth";

function App() {
  return (
    <ThemeConfig>
      <AuthProvider>
        <Router />
      </AuthProvider>
      <Toaster position="top-right" />
    </ThemeConfig>
  );
}

export default App;
